<template>
    <div class="banner">
        <div class="banner-container">
            <img :src="bannerObj.img"/>
            <div class="banner-content">
                <div class="banner-content-title">{{ bannerObj.title }}</div>
                <div class="banner-content-info" v-html="bannerObj.info"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Banner',
        props: {
            bannerObj: {
                type: Object
            }
        },
        data() {
            return {}
        },
        beforeMount() {
            this.change_linebreak()
        },
        methods: {
            change_linebreak: function() {
                if (window.innerWidth < 1024) {
                    this.bannerObj.info = this.bannerObj.info.replace(/<br\/>/g, '')
                }
            }
        },
        mounted() {
            this.$nextTick(() => {
                window.addEventListener('resize', () => {
                    this.change_linebreak()
                });
            })
        }
    }
</script>
